import { render, staticRenderFns } from "./TestAndroidWebView.vue?vue&type=template&id=36c1e2be&scoped=true&"
import script from "./TestAndroidWebView.vue?vue&type=script&lang=js&"
export * from "./TestAndroidWebView.vue?vue&type=script&lang=js&"
import style0 from "./TestAndroidWebView.vue?vue&type=style&index=0&id=36c1e2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1e2be",
  null
  
)

export default component.exports